import { Navigate, useNavigate } from 'react-router-dom';

import BackLink from '../components/BackLink';
import Footer from '../components/Footer';
import Scoreboard from '../components/Scoreboard';
import { OUTCOME_LABELS } from '../game';

function Result({ score, round }) {
  const navigate = useNavigate();

  // Reached by refresh or a direct link, with no round played yet.
  if (!round) {
    return <Navigate to="/Play" replace />;
  }

  return (
    <section className="gameSec">
      <div className="gameContainer">
        <div className="gameTop">
          <BackLink />
        </div>

        <Scoreboard score={score} />

        <div className="gameDiv">
          <div className="col">
            You picked
            <div className="player">
              <img src={round.player.img} alt={round.player.name} />
            </div>
          </div>

          <div className="winnerDiv">
            {OUTCOME_LABELS[round.outcome]}
            <button type="button" onClick={() => navigate('/Play')}>
              Play Again
            </button>
          </div>

          <div className="col">
            Computer picked
            <div className="player">
              <img src={round.computer.img} alt={round.computer.name} />
            </div>
          </div>
        </div>
      </div>
      <Footer className="ft" />
    </section>
  );
}

export default Result;
